import { render, staticRenderFns } from "./catalogue_verre.vue?vue&type=template&id=3b643cea&scoped=true&"
import script from "./catalogue_verre.vue?vue&type=script&lang=js&"
export * from "./catalogue_verre.vue?vue&type=script&lang=js&"
import style0 from "./catalogue_verre.vue?vue&type=style&index=0&id=3b643cea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b643cea",
  null
  
)

export default component.exports